import { render, staticRenderFns } from "./EditMainOffer.vue?vue&type=template&id=5513c7e7&scoped=true&"
import script from "./EditMainOffer.vue?vue&type=script&lang=js&"
export * from "./EditMainOffer.vue?vue&type=script&lang=js&"
import style0 from "./EditMainOffer.vue?vue&type=style&index=0&id=5513c7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513c7e7",
  null
  
)

export default component.exports